import styled from "styled-components";

export default styled.span`
borderWidth: 1px;
borderStyle: solid;
borderColor: ${props => props.background};
border-radius: 15px;
background: ${props => props.background};
padding: 5px 20px;
color: #000;
margin: 10px;
cursor: ${props => props.onClick ? "pointer" : "normal"}
`;